<template>
  <bk-view>

    <bk-title>Products</bk-title>

    <bk-title>STYLE STICK</bk-title>

    <bk-view class="image-wrap">
      <img
        src="https://static.wixstatic.com/media/7ceffa_ff09cce728a64a8784b8e14e04ef1a0d~mv2_d_6836_2020_s_2.jpg/v1/fit/w_342,h_101,q_90,enc_avif,quality_auto/7ceffa_ff09cce728a64a8784b8e14e04ef1a0d~mv2_d_6836_2020_s_2.jpg"
        alt="" loading="eager" style="width: 254px; height: 75px; user-select: none;"/>
    </bk-view>
    <bk-view class="image-wrap">

      <img
        src="https://static.wixstatic.com/media/7ceffa_d67c19f0b49c4ec299f2a4c7cbbb3138~mv2_d_6835_2022_s_2.jpg/v1/fit/w_342,h_101,q_90,enc_avif,quality_auto/7ceffa_d67c19f0b49c4ec299f2a4c7cbbb3138~mv2_d_6835_2022_s_2.jpg"
        alt="" loading="eager" style="width: 254px; height: 75px; user-select: none;"/>
    </bk-view>

    <bk-title>CURL STICK</bk-title>

    <bk-view class="image-wrap">
      <img
        src="https://static.wixstatic.com/media/7ceffa_10ba9cdd3cc04208902f84658217ed24~mv2_d_3005_4000_s_4_2.jpg/v1/fit/w_135,h_181,q_90,enc_avif,quality_auto/7ceffa_10ba9cdd3cc04208902f84658217ed24~mv2_d_3005_4000_s_4_2.jpg"
        alt="" loading="eager" style="width: 100px; height: 134px; user-select: none;">

      <img
        src="https://static.wixstatic.com/media/7ceffa_559aca7fbd9e40f79c77d0869252626c~mv2_d_3542_2362_s_2.jpg/v1/fit/w_269,h_181,q_90,enc_avif,quality_auto/7ceffa_559aca7fbd9e40f79c77d0869252626c~mv2_d_3542_2362_s_2.jpg"
        alt="" loading="eager" style="width: 200px; height: 134px; user-select: none;">
    </bk-view>


    <ProductImageWrap :title="item.title" :data-list="item.dataList" v-for="(item, index) in dataList" :key="index"/>


    <storeLocation @bookBtnClick="$emit('bookBtnClick')"/>

  </bk-view>
</template>


<script>
	import {
		kerastaseConditioner, kerastaseMasque,
		kerastaseShampoo, kerastaseTreatment,
		oribeConditioner,
		oribeDryShampoo,
		oribeMasques,
		oribeShampoo,
		oribeSprayMists
	} from './dataSource.js';
	import StoreLocation from '../storeLocation/storeLocation.vue';
	import ProductImageWrap from './productImageWrap.vue';

	export default {
		name: 'kisProducts',
		components: {ProductImageWrap, StoreLocation},
		props: {},
		data () {
			return {
				oribeConditioner,
				oribeShampoo,
				oribeDryShampoo,
				oribeSprayMists,
				oribeMasques,
				kerastaseShampoo,
				kerastaseConditioner,
				kerastaseMasque,
				kerastaseTreatment,
			};
		},
		computed: {
			dataList (){
				return [
					{
						title:'ORIBE CONDITIONER',
						dataList:this.oribeConditioner
					},
					{
						title:'ORIBE SHAMPOO',
						dataList:this.oribeShampoo
					},
					{
						title:'ORIBE DRY SHAMPOO',
						dataList:this.oribeDryShampoo
					},
					{
						title:'ORIBE SPRAY & MISTS',
						dataList:this.oribeSprayMists
					},
					{
						title:'ORIBE MASQUE',
						dataList:this.oribeMasques
					},
					{
						title:'KERASTASE SHAMPOO',
						dataList:this.kerastaseShampoo
					},
					{
						title:'KERASTASE CONDITIONER',
						dataList:this.kerastaseConditioner
					},
					{
						title:'KERASTASE MASQUE',
						dataList:this.kerastaseMasque
					},
					{
						title:'KERASTASE TREATMENT & SERUM',
						dataList:this.kerastaseTreatment
					}

				];
			}
		},
		watch: {},
		methods: {},
		mounted () {
			window.scrollTo(0, 0);
		}
	};
</script>

<style scoped lang="less">
.kisProducts {
  height: 100vh;
  overflow-y: auto;


}

.bk-title {
  font-size: 20px;
  width: 100%;
  text-align: center;
  margin: 20px auto;

}

.image-wrap {
}

.image-wrap, .image-scrollWrap {
  margin-bottom: 50px;
  padding: 0 25px;
  text-align: center;
}

.image-scrollWrap {
  width: 100%;
  width: 280px;
  display: flex;
  overflow-x: scroll;
  margin: 0 auto;
  // 实现一个图片无限从右往左滚动的动画

}
</style>